module.exports = __webpack_public_path__ + "media/qna.467d9b9b.mp3";